var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6053_27308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99219 21.25V23.75C4.99219 24.413 5.25558 25.0489 5.72442 25.5178C6.19326 25.9866 6.82915 26.25 7.49219 26.25H22.4922C23.1552 26.25 23.7911 25.9866 24.26 25.5178C24.7288 25.0489 24.9922 24.413 24.9922 23.75V21.25",
    stroke: "#2177FE",
    strokeWidth: 1.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.75L15 20L21.25 13.75",
    stroke: "#2177FE",
    strokeWidth: 1.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4.99902V19.999",
    stroke: "#2177FE",
    strokeWidth: 1.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6053_27308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadExport);
export default __webpack_public_path__ + "static/media/DownloadExport.16e15d4e2c4b313f0cab6cae46fc182e.svg";
export { ForwardRef as ReactComponent };